import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Loader2 } from 'lucide-react';

/**
 * PendingIdRequestsDialog
 * -----------------------
 * After the user uploads ID or lets us send it, offer to send their
 * documents to every *other* request that is currently waiting on ID.
 * State and the send action come from `useIdDocuments`.
 */
const PendingIdRequestsDialog = ({ open, onOpenChange, requests, sending, onSendToAll }) => {
  const count = requests.length;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Send your ID to the others too?</DialogTitle>
          <DialogDescription>
            {count === 1
              ? 'One other organisation has asked for proof of who you are.'
              : `${count} other organisations have asked for proof of who you are.`}
            {' '}Sending it now means their clocks keep running.
          </DialogDescription>
        </DialogHeader>
        <ul className="my-2 max-h-[220px] space-y-2 overflow-y-auto">
          {requests.map((pending, idx) => (
            <li key={pending.sar_id || idx} className="rounded-lg bg-ground px-4 py-3 text-[15px] text-ink">
              {pending.organisation_name}
            </li>
          ))}
        </ul>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Not now
          </Button>
          <Button onClick={onSendToAll} disabled={sending} data-testid="send-id-to-all-btn">
            {sending && <Loader2 className="h-4 w-4 animate-spin" />}
            Send to all {count}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PendingIdRequestsDialog;
